import './chunk-2452e3d3.js';
import './helpers.js';
import './chunk-8cad1844.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { I as Image } from './chunk-1b63211c.js';
export { I as BImage } from './chunk-1b63211c.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Image);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/image.js
// module id = Tuua
// module chunks = 0 1